import { BaseService } from '../infra/base.service'
import type { AppNotification } from './notification'
import type { NotificationsRepository } from './notifications.repository'

export class NotificationsService extends BaseService<AppNotification> {
    constructor(private rep: NotificationsRepository) {
        super(rep)
    }

    async markRead(id: string): Promise<AppNotification> {
        return await this.rep.markRead(id)
    }

    async markAllRead(): Promise<{ count: number }> {
        return await this.rep.markAllRead()
    }

    streamUrl(): string {
        return this.rep.streamUrl()
    }
}
